<template>
    <div>
        <div class="row">
            <div class="col text-portal-soft-black">
                <span v-html="introductionBlock"></span><a href="#" class="ml-1" v-on:click.prevent="showLearnMore = !showLearnMore">{{learnMoreBlock}}</a>
            </div>
        </div>

        <transition name="fade">
            <div class="mt-2 alert alert-dismissible fade show" role="alert" v-show="showLearnMore" style="background-color: #e0e0e0;">

                <div v-html="showMoreBlock" class="text-portal-soft-black"></div>

                <button v-on:click="showLearnMore = false" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </transition>

    </div>

</template>

<script>

    import Vue from 'vue';

    export default {
        name: 'medication-additional-information',
        props: {
            introductionBlock: { type: String },
            showMoreBlock: { type: String },
            learnMoreBlock: { type: String }
        },
        data: function () {
            return {
                showLearnMore: false
            }
        },
    };
</script>

